/** Accent colour for the crop frame, resize/rotate dots, badges and dial. */
export const CROP_ACCENT_COLOR = '#0284C7'
